"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = mediateItem;

var _init = _interopRequireDefault(require("../_core/init"));

// creates item mediator
function createItemMediator(_ref) {
  var arr = _ref.arr,
      mediator = _ref.mediator;
  return function itemMediator(value, index) {
    // args: value, old value, index, array itself
    return mediator.call(arr, value, index, arr);
  };
} // defines a "type" of every array item


function mediateItem(mediator) {
  var def = (0, _init["default"])(this);
  var length = this.length; // store itemMediator in object definition

  var itemMediator = def.itemMediator = createItemMediator({
    arr: this,
    mediator: mediator
  }); // convert existing items

  for (var i = 0; i < length; i++) {
    this[i] = itemMediator(this[i], i);
  }

  return this;
}
//# sourceMappingURL=mediateitem.js.map